var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comp-main"},[_c('el-empty',{attrs:{"image":_vm.image,"image-size":_vm.imageSize,"description":_vm.description}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }